<template>
    <div id="top-actions-small-card">
        <div class="red-section"></div>
        <div class="grey-wrapper">
            <p class="small-card-header">
                {{ $i18nApi.t("checkout1Right.order") }}
            </p>
        </div>

        <div class="section-wrapper" v-if="Object.keys(mobileTariff).length">
            <div class="inner-section-wrapper">
                <p class="text-light">{{ $i18nApi.t("checkout1Right.tariff") }}</p>
                <p class="text-large">{{ mobileTariff.name }}</p>
            </div>
            <div class="inner-section-wrapper">
                <p
                    class="text-semi-light"
                    v-html="$options.filters.priceFilter(mobileTariff.total)"
                ></p>
            </div>
            <div
                class="inner-section-wrapper"
                v-if="spec.action"
            >
                <p class="text-semi-light text-align-left">
                    * {{ spec.action_text }} 
                </p>
                <p class="text-semi-light text-align-left" v-if="spec.additional_action_text">
                    * {{ spec.additional_action_text }}
                </p>
                <div class="inner-section-wrapper ">
                    <p class="text-extra-bold">{{ $i18nApi.t("checkout2Right.totalAction") }}</p>
                    <p
                        class="text-bold"
                        v-html="$options.filters.priceFilter(actionTotals.oldPrice)"
                    ></p>
                </div>
            </div>
        </div>

        <div class="section-wrapper" v-if="!Object.keys(mobileTariff).length">
            <div class="inner-section-wrapper" v-if="Object.keys(sIM).length">
                <p class="text-light">
                    {{ $i18nApi.t("checkout2.sim") }}
                </p>
                <p class="text-large">{{ sIM.name | uppercase }}</p>
            </div>

            <div
                class="inner-section-wrapper"
                v-if="
                    Object.keys(tVTariff).length &&
                    !Object.keys(mobileTariff).length
                "
            >
                <p class="text-light">
                    {{ $i18nApi.t("checkout1Right.tariff") }}
                </p>
                <p class="text-large">{{ tVTariff.name }}</p>
            </div>

            <div class="inner-section-wrapper" v-if="binding">
                <p v-if="!Object.keys(tVTariff).length">
                    {{ $i18nApi.t("checkout1Right.duration") }}
                </p>
                <p v-else></p>
                <div class="inner-section-wrapper">
                    <p v-if="!Object.keys(tVTariff).length" class="text-semi-light">{{ bindingFirst }}</p>
                    <p class="text-semi-light" v-if="Object.keys(mobileTariff).length">
                        <span
                            v-html="
                                $options.filters.priceFilter(
                                    mobileTariff.total
                                )
                            "
                        ></span>
                    </p>
                    <p class="text-semi-light" v-else-if="Object.keys(sIM).length">
                        <span
                            v-html="$options.filters.priceFilter(sIM.total)"
                        ></span>
                    </p>

                    <p class="text-semi-light"
                        v-else-if="
                            Object.keys(tVTariff).length &&
                            !Object.keys(mobileTariff).length
                        "
                    >
                        <template v-if="tVTariff.postpaid === 0"
                            ><span
                                v-html="
                                    $options.filters.priceFilter2(
                                        tVTariff.total
                                    )
                                "
                            ></span
                        ></template>
                        <template v-else
                            ><span
                                v-html="
                                    $options.filters.priceFilter(
                                        tVTariff.total
                                    )
                                "
                            ></span
                        ></template>
                    </p>
                </div>
                <div
                    class="inner-section-wrapper"
                    v-if="spec.action"
                >
                    <p class="text-semi-light text-align-left">
                        * {{ spec.action_text }}
                    </p>
                    <div class="inner-section-wrapper ">
                        <p class="text-extra-bold">{{ $i18nApi.t("checkout2Right.totalAction") }}</p>
                        <p
                            class="text-bold"
                            v-html="$options.filters.priceFilter(actionTotals.oldPrice)"
                        ></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-wrapper">
            <div
                class="inner-section-wrapper"
                v-if="
                    (Object.keys(tVTariff).length &&
                        Object.keys(mobileTariff).length) ||
                    Object.keys(device).length ||
                    Object.keys(tVdevice).length ||
                    (bundle && bundle.length) ||
                    checkout.limit > 0 ||
                    checkout.postBill === true ||
                    (checkout.insurance && Number(checkout.insurance) > 0)
                "
            >
                <template v-if="Object.keys(device).length">
                    <p class="text-semi-light">
                        {{ $i18nApi.t("checkout1Right.device") }}
                    </p>
                    <p class="text-extra-bold">{{ device.name }}</p>
                    <div class="inner-section-wrapper_price">
                        <p class="pk-title-v2a duration-title"></p>
                        <p
                            class="text-bold"
                            v-html="
                                $options.filters.priceFilter(device.billing)
                            "
                        ></p>
                    </div>
                </template>
                <template v-if="Object.keys(tVdevice).length">
                    <p class="text-semi-light">
                        {{ $i18nApi.t("checkout1Right.stb") }}
                    </p>
                    <p class="text-extra-bold">{{ tVdevice[0].name }}</p>
                    <div class="inner-section-wrapper_price">
                        <template v-if="tVdevice[0].postpaid === 0">
                            <p
                                class="text-bold"
                                v-html="
                                    $options.filters.priceFilter2(
                                        tVdevice[0].total
                                    )
                                "
                            ></p>
                        </template>
                        <template v-else>
                            <p class="pk-title-v2a"></p>
                            <p
                                class="text-bold"
                                v-html="
                                    $options.filters.priceFilter(
                                        tVdevice[0].total
                                    )
                                "
                            ></p>
                        </template>
                    </div>
                </template>

                <template v-if="Object.keys(tVdevice).length && tVdevice[1]">
                    <p class="text-extra-bold">{{ tVdevice[1].name }}</p>
                    <div class="inner-section-wrapper_price">
                        <template v-if="tVdevice[1].postpaid === 0">
                            <p
                                class="text-bold"
                                v-html="
                                    $options.filters.priceFilter2(
                                        tVdevice[1].total
                                    )
                                "
                            ></p>
                        </template>
                        <template v-else>
                            <p class="pk-title-v2a"></p>
                            <p
                                class="text-bold"
                                v-html="
                                    $options.filters.priceFilter(
                                        tVdevice[1].total
                                    )
                                "
                            ></p>
                        </template>
                    </div>
                </template>

                <template
                    v-if="
                        Object.keys(mobileTariff).length &&
                        bundle &&
                        bundle.length
                    "
                >
                    <p class="text-extra-bold">
                        {{ $i18nApi.t("checkout1Right.bundle") }} <br />
                        {{ $i18nApi.t("checkout2Right.oneTime") }}
                    </p>
                    <div class="inner-section-wrapper_price" v-for="b in bundle">
                        <p class="text-extra-bold">{{ b.name }}</p>
                        <p
                            class="text-bold"
                            v-html="$options.filters.priceFilter2(b.oneTime)"
                        ></p>
                    </div>
                </template>

                <template
                    v-if="
                        !Object.keys(mobileTariff).length &&
                        bundle &&
                        bundle.length
                    "
                >
                    <p class="text-extra-bold">
                        {{ $i18nApi.t("checkout1Right.bundle") }}
                    </p>
                    <div class="inner-section-wrapper_price" v-for="b in bundle">
                        <p class="text-extra-bold">{{ b.name }}</p>
                        <p
                            class="text-bold"
                            v-html="$options.filters.priceFilter(b.total)"
                        ></p>
                    </div>
                </template>

                <template v-if="checkout.limit > 0">
                    <p>
                        {{ $i18nApi.t("checkout1Right.limit") }}
                    </p>
                    <div class="inner-section-wrapper_price">
                        <p class="text-extra-bold">
                            {{ $i18nApi.t("checkout1Right.limitExplain") }} CHF
                            {{ checkout.limit }}.-
                        </p>
                    </div>
                </template>

                <template
                    v-if="checkout.insurance && Number(checkout.insurance) > 0"
                >
                    <p>
                        {{ $i18nApi.t("checkout1Right.insurance") }}
                    </p>
                    <div class="inner-section-wrapper_price">
                        <p class="text-extra-bold">
                            {{ $i18nApi.t("checkout1Right.bonusDesc") }}
                        </p>
                        <p
                            class="text-bold"
                            v-html="
                                $options.filters.priceFilter(
                                    device.insurancePrice
                                )
                            "
                        ></p>
                    </div>
                </template>

                <template v-if="checkout.postBill">
                    <p>
                        {{ $i18nApi.t("checkout1Right.postBill") }}
                    </p>
                    <div class="inner-section-wrapper_price">
                        <p class="text-extra-bold">
                            {{ $i18nApi.t("checkout1Right.postBillDescription") }}
                        </p>
                        <p
                            class="text-bold"
                            v-html="$options.filters.priceFilter('3,90')"
                        ></p>
                    </div>
                </template>

                <template
                    v-if="
                        Object.keys(tVTariff).length &&
                        Object.keys(mobileTariff).length
                    "
                >
                    <p>
                        {{ $i18nApi.t("checkout1Right.bonus") }}
                    </p>
                    <p class="text-extra-bold">
                        {{ $i18nApi.t("checkout1Right.bonusTitle") }}
                        {{ chosenTv.name }}
                    </p>
                    <div class="inner-section-wrapper_price">
                        <p class="pk-title-v2a duration-title">
                            {{ $i18nApi.t("checkout1Right.bonusDesc") }}
                        </p>
                        <p class="text-bold">
                            {{ $i18nApi.t("checkout1.afterThat") }} €
                            {{ chosenTv.billing
                            }}<span class="text-extra-bolda">{{
                                $i18nApi.t("mo")
                            }}</span>
                        </p>
                    </div>
                </template>
            </div>

            <template
                v-if="
                    Object.keys(mobileTariff).length &&
                    !Object.keys(device).length
                "
            >
                <div class="inner-section-wrapper " v-if="parseInt(rightSide.billing) > 0">
                    <p class="text-extra-bold">{{ $i18nApi.t("checkout2Right.oneTimeTotal") }}</p>
                    <p class="text-bold"
                        v-html="
                            $options.filters.priceFilterWithoutMo(
                                rightSide.oneTime
                            )
                        "
                    ></p>
                </div>

                <div class="inner-section-wrapper ">
                    <p class="text-extra-bold" v-if="parseInt(rightSide.billing) > 0">
                        {{ $i18nApi.t("checkout2Right.totalSimOnly") }}
                    </p>
                    <p class="text-extra-bold" v-else>{{ $i18nApi.t("checkout2Right.total") }}</p>
                    <p class="text-bold"
                        v-html="$options.filters.priceFilter(rightSide.total)"
                    ></p>
                </div>
            </template>

            <template
                v-if="
                    !Object.keys(device).length &&
                    !Object.keys(mobileTariff).length
                "
            >
                <div class="inner-section-wrapper " v-if="parseInt(rightSide.billing) > 0 && !Object.keys(tVTariff).length">
                    <p class="text-extra-bold">{{ $i18nApi.t("checkout2Right.oneTimeTotal") }}</p>
                    <p
                        v-html="
                            $options.filters.priceFilterWithoutMo(
                                rightSide.billing
                            )
                        "
                    ></p>
                </div>

                <div class="inner-section-wrapper ">
                    <p class="text-extra-bold" v-if="parseInt(rightSide.billing) > 0">
                        {{ $i18nApi.t("checkout2Right.totalSimOnly") }}
                    </p>
                    <p v-else>{{ $i18nApi.t("checkout2Right.total") }}</p>
                    <p class="text-bold"
                        v-if="rightSide.postpaid"
                        v-html="$options.filters.priceFilter(rightSide.total)"
                    ></p>
                    <p class="text-bold"
                        v-else
                        v-html="$options.filters.priceFilterWithoutMo(rightSide.total)"
                    ></p>
                </div>
            </template>
            <template v-if="Object.keys(device).length">
                <div class="inner-section-wrapper " v-if="parseInt(rightSide.oneTime) > 0">
                    <p class="text-extra-bold">{{ $i18nApi.t("checkout2Right.oneTimeTotal") }}</p>
                    <p class="text-bold"
                        v-html="
                            $options.filters.priceFilterWithoutMo(
                                rightSide.oneTime
                            )
                        "
                    ></p>
                </div>

                <div class="inner-section-wrapper ">
                    <p class="text-extra-bold">{{ $i18nApi.t("checkout2Right.total") }}</p>
                    <p class="text-bold"
                        v-html="$options.filters.priceFilter(rightSide.billing)"
                    ></p>
                </div>
            </template>

            <template v-if="showContinue">
                <a
                    class="button--checkout-pionter cart_button"
                    v-if="canContinueButton"
                    @click="checkCanContiueTv"
                >
                    <div class="cart_btn_text">
                        <p>{{ $i18nApi.t("continue") }}</p>
                    </div>
                </a>
                <a class="button--checkout-pionter cart_button disabled" v-else>
                    <div class="cart_btn_text">
                        <p>{{ $i18nApi.t("continue") }}</p>
                    </div>
                </a>
            </template>
        </div>
        <template v-if="buyButtonForTopAction">
            <div class="red-section-wrapper">
                <div class="red-section section--bottom">
                    <button type="button" class="text-uppercase business-buy">
                        <a v-if="hasExternalUrl"  :href="this.spec.external_checkout_url" class="text-uppercase text-padding" target="_blank">
                            {{ $i18nApi.t("continue") }}
                        </a>
                        <a v-else href="" class="text-uppercase text-padding" @click="buyTopAction">
                            {{ $i18nApi.t("continue") }}
                        </a>
                    </button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import RightContainerNew from "./RightContainerNew";
export default RightContainerNew;
</script>

<style scoped>
a.disabled:hover {
    cursor: not-allowed;
}
a:hover {
    cursor: pointer;
}
</style>
